import React, { useState, useEffect, useRef } from "react";

import { formatFileSize } from './filemanager/filemanager-utils'

function FileUpload({ handleFileToUpload, uploadURL }) {
	const fileInputRef = useRef(null);
	const [files, setFiles] = useState([]);

	const dropHandler = async (event) => {
		event.preventDefault()
		const files = event.dataTransfer.files;
		handleFileChange(files);
	}

	const dragOverHandler = async (event) => {
		event.preventDefault()
	}

	const handleFileChange = (files) => {
		const selectedFiles = Array.from(files).map((file, index ) => {
			const fileExtension = file.name.split('.').pop().toLowerCase();
		
			let status = 'IN_PROGRESS';
			let error = '';
			if (!hp.settings.allowedFileExtensions.includes(fileExtension)) {
				status = 'INVALID_FILE';
				error = __('files_upload_invalid_extension');
			} else if (file.size > hp.settings.maxUploadSize) {
				status = 'INVALID_FILE';
				error = __('files_upload_size_exceeded', {maxUploadSize: maxUploadFile()});
			}

			return {
				name: file.name,
				formattedName: file.name.length > 12 ? `${file.name.substring(0, 13)}... .${file.name.split('.')[1]}` : file.name,
				formattedSize: `${formatFileSize(Number(file.size), 2)}.`,
				type: file.type,
				progress: 0, 
				status: status,
				error: error, 
				preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
				file: file
			}
		});
	  
		setFiles((prevFiles) => {
			const filesUploading = [...selectedFiles, ...prevFiles];
			return filesUploading
		});
		
	};

	const handleClick = () => {
		fileInputRef.current.click();
	};

	const handleDelete = (fileToDelete) => {
		setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileToDelete.name));
	};

	const maxUploadFile = () => {
		return (hp.settings.maxUploadSize / 1048576).toFixed(0);
	}

	const onUpload = async () => {
		files.filter(item => item.status !== 'FINISH_PROGRESS' && item.status !== 'INVALID_FILE').forEach((file) => {
			const formData = new FormData();

			formData.append("file", file.file);
			formData.append("name", file.name);

		   
			http.post(uploadURL, { data: formData }, async response => {

				const responseData = {
					status: response.ok ? "FINISH_PROGRESS" : "FAILED_PROGRESS",
					progress: response.ok ? 100 : 85,
					error: response.ok ? null : (response.error || __('files_upload_size_error')),
				}
			
				setFiles((prevFiles) =>
					prevFiles.map((f) =>
						f.name === file.name
						? { ...f, ...responseData }
						: f
				));

				await handleFileToUpload({ ...file, ...responseData });
				if (response.ok) {
					setTimeout(() => {
						mbox.dismiss();
					}, 2000);
				}
			})
		})
	};
	
	const isSubmitDisabled = () => {
		return files.length === 0 || files.some(item => item.status === 'INVALID_FILE') || files.every(item => item.status === 'FINISH_PROGRESS')
	}

	return (
		<div className="container-upload">
			<div id="drop_zone" onClick={handleClick} onDrop={dropHandler} onDragOver={dragOverHandler}>
				<em className="la la-cloud-upload"></em>
				<h1 className="upload-drag-title">{__('files_upload')}</h1>
				<p className="secondary-text"> {__('files_upload_subtitle')}</p>
				<input
					type="file"
					ref={fileInputRef}
					style={{ display: "none" }} 
					multiple 
					onChange={event => handleFileChange(event.target.files)}
				/>
			</div>
			<div className="container-list-files">
				{files.map((file, key) => (
					<div className="content-card-list-files" key={key}>
						<div className="thumb-image">
							{file.preview ? (
								<img src={file.preview} alt={file.name} />
							) : (
								<div className="file-extension">{file.name.split(".").pop().toUpperCase()}</div>
							)}
						</div>
						<div className="content-file">
							<div className={`file-title primary-text ${file?.status?.toLowerCase()}`} title={file.name}>{file.formattedName}</div>
							<div className={`file-size secondary-text ${file?.status?.toLowerCase()}`}>{file.formattedSize}</div>
							<div className="file-progress">
								<div className="bar-progress">
									<div className={`file-progress-bg ${file?.status?.toLowerCase()}`} style={{ width: `${file.progress ?? 0}%` }}></div>
								</div>
								<div className="count-progress secondary-text">{`${file.progress ?? 0}%`}</div>
							</div>
							{file.error && <div className="file-error secondary-text" style={{ color: "red" }}>{file.error}</div>}
						</div>

						<div className="handle-action-upload">
							{file.status === 'FAILED_PROGRESS' ? (
							   <em className="la la-refresh" onClick={onUpload} title={__('files_upload_try_again')}></em>
							) : file.status === 'IN_PROGRESS' || file.status === 'INVALID_FILE' ? (
								<em className="la la-close" onClick={() => handleDelete(file)}></em>
							) : null} 
						</div>
					</div>
					
				))}
			</div>
			<div className="upload-toolbar flex-center">
				<div>
					<em className="la la-info-circle upload-info" />
					<span className="alert-none">{ __("files_upload_max_size", {maxUploadSize: maxUploadFile()})}</span>
				</div>
				<button className="upload-submit" disabled={isSubmitDisabled()} onClick={onUpload}>
					<em className="la la-check" />
					<span>{__('buttons_submit')}</span>
				</button>
			</div>
		</div>
	);
}

export default FileUpload;
